import { motion } from 'framer-motion';
import { styled } from '@mui/material/styles';
import AlertTitle from '@mui/material/AlertTitle';
import CircularProgress from '@mui/material/CircularProgress';
var borderRadius = function borderRadius(edges, theme) {
  switch (edges) {
    case 'rounded':
      return 99;
    case 'sharp':
      return 0;
    default:
      return theme.shape.borderRadius;
  }
};
export var StyledAlertTitle = styled(AlertTitle)({
  fontSize: 14,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  marginBottom: 0
});
export var StyledLoader = styled(CircularProgress)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  marginTop: -20,
  marginLeft: -20,
  zIndex: 1
});
export var StyledSavedWrapper = styled(motion.div)(function (_ref) {
  var edges = _ref.edges,
    theme = _ref.theme;
  return {
    borderRadius: borderRadius(edges, theme),
    border: "1px solid " + theme.palette.text.secondary,
    padding: theme.spacing(6, 4),
    '& .MuiAlert-message': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  };
});